<!-- ==========================================
     HEADER COMPLET FIGMA - 2 BARRES
     ==========================================

     Structure Figma :
     1. Top Bar (vert) avec langues + FAQ
     2. Main Header (blanc) avec logo + menus
     ========================================== -->

<!-- Première barre (Top Bar) -->
<app-top-bar-figma-new></app-top-bar-figma-new>

<!-- Deuxième barre (Main Header) - Composant Figma -->
<app-main-header-figma></app-main-header-figma>